export default "__VITE_ASSET__2ad23087__"